import {
  fetchUserCheck,
  fetchUserSettings,
  postCookieLogin,
  postCookieLogout,
} from '../apis/api-users.ts';
import type {UserLogin} from '../apis/api-users.ts';
import {userSettings$, user$} from '../stores/store-user.ts';
import {USER_ROLE} from './helper-users.ts';
import {setUserStatus} from './keycloakUser.ts';

export async function cookieLogin(
  username: string,
  password: string,
): Promise<boolean> {
  try {
    const userData = await postCookieLogin(username, password);
    if (userData.loginErrorCode === 200) {
      user$.next(userData);
      const userSettings = await fetchUserSettings();
      userSettings$.next(userSettings);
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

export async function cookieLoginWithErrors(
  username: string,
  password: string,
): Promise<UserLogin> {
  const userData = await postCookieLogin(username, password);
  if (userData.loginErrorCode === 200) {
    user$.next({
      userid: userData.userid,
      email: userData.email,
      firstName: userData.firstName,
    });
    const userSettings = await fetchUserSettings();
    userSettings$.next(userSettings);
  }
  return userData;
}

export async function cookieLogout() {
  await postCookieLogout();
  user$.next(null);
  userSettings$.next(null);
}

export async function initializeUserWithCookie(): Promise<boolean> {
  const data = await fetchUserCheck();
  if (data.loggedin) {
    user$.next({
      userid: data.userid,
      email: data.email,
      firstName: data.firstName,
    });
    setUserStatus({
      email: data.email,
      roles: [USER_ROLE.subscribedUser],
    });
    const userSettings = await fetchUserSettings();
    userSettings$.next(userSettings);
    return true;
  }
  return false;
}
